import { render, staticRenderFns } from "./BConfigurationPreview.vue?vue&type=template&id=0def9a46&"
import script from "./BConfigurationPreview.vue?vue&type=script&lang=ts&"
export * from "./BConfigurationPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports